export const createExposeCurrentFrameAndCurrentTime = window => {
  return (currentTime, sampleRate, fn) => {
    Object.defineProperties(window, {
      currentFrame: {
        configurable: true,
        get() {
          return Math.round(currentTime * sampleRate);
        }
      },
      currentTime: {
        configurable: true,
        get() {
          return currentTime;
        }
      }
    });
    try {
      return fn();
    } finally {
      if (window !== null) {
        delete window.currentFrame;
        delete window.currentTime;
      }
    }
  };
};